<template>
    <Pagebody :subnav="[{
      text:'签订购买服务协议',
      color:'#bc0101'
  }]">
        <h1 class="order-title">{{orderTitle}}</h1>
        <div class="info-area">
            <div class="info-item">
                <div class="info-head">姓名或机构名称</div>
                <div class="info-body"></div>
                <div class="info-tips"></div>
            </div>
        </div>
    </Pagebody>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'Order',
        components: {

        },
        data: () => ({
            orderTitle: '购买服务协议'
        })
    }
</script>

<style scoped>
    .order-title {
        margin: 0;
        padding: 23px 0;
        font-size: 20px;
        text-align: center;
        color: #343434;
        font-weight: normal;
    }

    .info-area {
        background: #F7F7F7;
        padding: 26px 0 30px 0;
        margin-bottom: 35px;
    }

    .info-item {
        width: 755px;
        margin: 0 auto;

    }

    .info-item .info-head {
        float: left;
        width: 120px;
    }

    .info-item .info-body {
        float: left;
        width: 240px;
        padding: 2px 10px;
        margin: 0 5px;
        height: 19px;
        border: 1px solid #cdcdcd;
        float: left;
        background: #fff;
        text-align: left;
    }

    .info-item .info-tips {
        float: left;
    }
</style>